import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import * as React from 'react';
import { Icon } from '../Icon';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var PadlockSquareSvg = function PadlockSquareSvg() {
  return /*#__PURE__*/_jsxs("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    viewBox: "0 0 24 25",
    children: [/*#__PURE__*/_jsx("path", {
      fill: "currentColor",
      d: "M11.314 15.04v2.79h1.372v-2.79z"
    }), /*#__PURE__*/_jsx("path", {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M6.743 7.598v3.023H4V22.25h16V10.621h-2.743V7.598c0-1.419-.554-2.78-1.54-3.782A5.21 5.21 0 0 0 12 2.249a5.21 5.21 0 0 0-3.717 1.567 5.4 5.4 0 0 0-1.54 3.782M12 3.644c-1.03 0-2.019.417-2.748 1.158a4 4 0 0 0-1.138 2.796v3.023h7.772V7.598c0-1.049-.41-2.054-1.138-2.796A3.85 3.85 0 0 0 12 3.644m-6.629 8.373v8.837H18.63v-8.837z",
      clipRule: "evenodd"
    })]
  });
};
export var PadlockSquare = function PadlockSquare(props) {
  return /*#__PURE__*/_jsx(Icon, _objectSpread(_objectSpread({}, props), {}, {
    component: PadlockSquareSvg
  }));
};